import { Item } from "../../../services/Item";
import './tableDetails.css';
import TableDetails from "./tableDetails";
import StagesList from "./stagesList";
import { getTableColumns } from "./tableColumns";

interface TableDetailsWrapperProps {
    item: Item
}

const TableDetailsWrapper = ({ item }: TableDetailsWrapperProps) => {
    const startTableBids = (item?.tablePlanning?.length || 0) + 1;
    const startTableEvaluation = startTableBids + (item?.tableBids?.length || 0);
    const startTableCommitteeReview = startTableEvaluation + (item?.tableEvaluation?.length || 0);
    const startTableContractAward = startTableCommitteeReview + (item?.tableCommitteeReview?.length || 0);
    const startTableContractManagement = startTableContractAward + (item?.tableContractAward?.length || 0);

    
    return (
        <>
            <StagesList item={item} />
            <TableDetails
                dataSource={item?.tablePlanning ?? []}
                columns={ getTableColumns(1)}
                title="Planning and Preparatory stage"
            />
            <TableDetails
                dataSource={item?.tableBids ?? []}
                columns={getTableColumns(startTableBids)}
                title="Bids Solicitation"
            />
            <TableDetails
                dataSource={item?.tableEvaluation ?? []}
                columns={getTableColumns(startTableEvaluation)}
                title="Evaluation"
            />
            <TableDetails
                dataSource={item?.tableCommitteeReview ?? []}
                columns={getTableColumns(startTableCommitteeReview)}
                title="Committee Review"
            />
            <TableDetails
                dataSource={item?.tableContractAward ?? []}
                columns={getTableColumns(startTableContractAward)}
                title="Contract Award"
            />
            <TableDetails
                dataSource={item?.tableContractManagement ?? []}
                columns={getTableColumns(startTableContractManagement)}
                title="Contract Management"
            />
        </>
    );
};

export default TableDetailsWrapper;